import { Enlace } from '../../router';
import logo from './logo.png';

interface PropsLogo {
  tamano?: number;
  conTexto?: boolean;
  /** Ruta a la que lleva al pulsarlo. Sin ruta, el logo no es un enlace. */
  a?: string;
}

export function Logo({ tamano = 32, conTexto = true, a }: PropsLogo) {
  const contenido = (
    <>
      <img
        src={logo}
        alt={conTexto ? '' : 'MedChoice'}
        width={tamano}
        height={tamano}
        className="logo__imagen"
        style={{ borderRadius: tamano / 4 }}
      />
      {conTexto && <span className="logo__texto">MedChoice</span>}
    </>
  );

  if (!a) return <span className="logo">{contenido}</span>;
  return <Enlace a={a} className="logo logo--enlace" aria-label="MedChoice, ir a la portada">{contenido}</Enlace>;
}
